import React, { Component } from 'react'
import { Col, Well, Collapse, Button } from 'react-bootstrap'
import '../style.css'

import PublicationFilter from './PublicationFilter'

class PublicationFilterContainer extends Component {
  state = {
    smallScreenFiltersOpen: false,
  }

  toggleOpen = () => this.setState({ smallScreenFiltersOpen: !this.state.smallScreenFiltersOpen })

  render() {
    return (
      <div id="PublicationFilter">

        <Col xsHidden smHidden id="large-device">
          <Well>
            <PublicationFilter
              changePage={this.props.changePage}
              history={this.props.history}
            />
          </Well>
        </Col>

        <Col mdHidden lgHidden>
          <div id="filter-display-button">
            <Button onClick={this.toggleOpen}>
              Filters
            </Button>
          </div>
          <Collapse in={this.state.smallScreenFiltersOpen}>
            <Well>
              <PublicationFilter
                changePage={this.props.changePage}
                history={this.props.history}
              />
            </Well>
          </Collapse>
        </Col>

      </div>
    )
  }
}

export default PublicationFilterContainer



// WEBPACK FOOTER //
// ./src/routes/publications/components/PublicationFilterContainer.js